<template>
  <div :id="localeClass" class="platform__pc">
    <nuxt />
    <no-ssr>
      <!-- 登录及绑定邮箱弹窗 -->
      <LoginDialog
        v-if="showDialogs.login"
        :show.sync="showDialogs.login"
        :success-url="dialogArgs.login.successUrl"
        :trigger-src="dialogArgs.login.triggerSrc"
        :login-trigger-source="dialogArgs.login.triggerSource"
        :is-group="dialogArgs.login.isGroup"
      />
      <BindEmailDialog
        v-if="showDialogs.bindEmail"
        :show.sync="showDialogs.bindEmail"
        :success-url="dialogArgs.bindEmail.successUrl"
        :trigger-src="dialogArgs.bindEmail.triggerSrc"
      />
      <CompleteStuInfoDialog
        v-if="showDialogs.completeStuInfo"
        ref="completeStuInfoDialog"
        :trigger-args="dialogArgs.completeStuInfo"
      />
      <UnpaidDialog v-if="showDialogs.unpaid" ref="unpaidDialog" />
      <BindDialog />
      <OnlineService v-if="shouldShowOnlineService" />
      <AppointmentDiagnosis
        v-if="showDialogs.diagnosis"
        :show.sync="showDialogs.diagnosis"
        :diagnosis-info="dialogArgs.diagnosis"
      />
    </no-ssr>
  </div>
</template>

<script>
import bus from 'common/bus';
import headMixin from 'mixins/layout/head';
import { getFaviconLink } from 'common/utils.js';

// 按需加载组件
const OnlineService = () => import('components/common/OnlineService/index.vue');
const LoginDialog = () => import('components/login/LoginDialog/index.vue');
const BindEmailDialog = () => import('components/login/BindEmailDialog/index.vue');
const CompleteStuInfoDialog = () => import('components/login/CompleteStuInfoDialog/index.vue');
const UnpaidDialog = () => import('components/common/UnpaidDialog/index.vue');
const BindDialog = () => import('components/common/bindDialog/index.vue');
const AppointmentDiagnosis = () => import('components/appointmentDiagnosis/index.vue');

export default {
  components: {
    OnlineService, LoginDialog, BindEmailDialog, CompleteStuInfoDialog, UnpaidDialog, BindDialog, AppointmentDiagnosis,
  },
  mixins: [headMixin],
  data() {
    return {
      showDialogs: {
        login: false,
        bindEmail: false,
        completeStuInfo: false,
        unpaid: false,
        diagnosis: false,
      },
      dialogArgs: {
        login: {
          successUrl: '',
          triggerSrc: '',
          triggerSource: '',
          isGroup: false,
        },
        bindEmail: {
          successUrl: '',
          triggerSrc: '',
        },
        completeStuInfo: null,
        diagnosis: {},
      },
      eventListeners: {},
    }
  },
  computed: {
    localeClass() {
      return `locale__${this.$store.state.locale}`;
    },
    shouldShowOnlineService() {
      return this.$store.state.locale === 'sg' || this.$store.state.locale === 'uk';
    },
  },
  created() {
    // 使用对象统一管理事件监听器
    this.eventListeners = {
      login: this.handleLogin,
      toShowDiagnosis: this.handleShowDiagnosis,
      'complete-stu-info': this.handleCompleteStuInfo,
      openUnpaidDialog: this.handleOpenUnpaidDialog,
    };

    // 注册所有事件监听器
    Object.entries(this.eventListeners).forEach(([event, handler]) => {
      bus.$on(event, handler);
    });
  },
  beforeDestroy() {
    // 移除所有事件监听器
    Object.entries(this.eventListeners).forEach(([event, handler]) => {
      bus.$off(event, handler);
    });
  },
  methods: {
    handleLogin(argsObj = {}) {
      this.dialogArgs.login = {
        ...this.dialogArgs.login,
        ...argsObj,
      };
      this.showDialogs.login = true;
    },
    handleShowDiagnosis(argsObj = {}) {
      this.dialogArgs.diagnosis = argsObj;
      this.showDialogs.diagnosis = true;
    },
    handleBindEmail(argsObj = {}) {
      this.dialogArgs.bindEmail = {
        ...this.dialogArgs.bindEmail,
        ...argsObj,
      };
      this.showDialogs.bindEmail = true;
    },
    handleCompleteStuInfo(argsObj) {
      this.dialogArgs.completeStuInfo = argsObj;
      this.showDialogs.completeStuInfo = true;
      if (this.$refs.completeStuInfoDialog) this.$refs.completeStuInfoDialog.openDialog(argsObj);
    },
    handleOpenUnpaidDialog() {
      this.showDialogs.unpaid = true;
      if (this.$refs.unpaidDialog) this.$refs.unpaidDialog.openDialog();
    },
    reload() {
      if (this.$nuxt.isOffline) return;
      window.location.reload();
    },
  },
  head() {
    const betterme = this.$store.state.betterme === 'bettermeedu' ? 'bettermeedu' : 'default';
    return {
      ...headMixin.head.call(this),
      htmlAttrs: {
        id: `style__${this.$store.state.betterme}`,
      },
      link: getFaviconLink(betterme),
    }
  },
}
</script>
